import { userResponse } from "./queries";

export const putSettings = `mutation PutSettings($data: String!) {
  putSettings(data: $data) {
    ${userResponse}
  }
}`;

export const resetDeviceId = `mutation ResetDeviceId {
  resetDeviceId {
    ${userResponse}
  }
}`;

export const updateDeviceOrder = `mutation UpdateDeviceOrder(
  $updateDeviceOrderInput: UpdateDeviceOrderInput) {
  updateDeviceOrder(updateDeviceOrderInput: $updateDeviceOrderInput) {
    success
  }
}`;

export const createWaitlistEntry = `mutation CreateWaitlistEntry {
  createWaitlistEntry {
    stockOnHand
  }
}`;
